import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { Button } from 'src/components-dummy';
import { experimentRoutes } from 'src/app-routes';
import { useAppSelector } from 'src/hooks';

export const ExperimentGoToDashboardButton = (): JSX.Element | null => {
  const history = useHistory();
  const shopId = useAppSelector(state => state.shop.current?.shopId);
  const experimentId = useAppSelector(state => state.experiments.selectedExperiment?.id);

  if (!shopId || !experimentId) return null;

  const path = generatePath(experimentRoutes.abTestDashboard.path, { shopId, experimentId });

  const onGoToDashboard = (): void => {
    history.push(path);
  };

  return (
    <Button variant='secondary' onClick={onGoToDashboard} className='experiments-btn-dashboard'>
      Go to Dashboard
    </Button>
  );
};
